module.exports = __webpack_public_path__ + "static/img/img_2.a516f0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_2.png
// module id = V32x
// module chunks = 0